export default __webpack_public_path__ + "static/media/kuchnia1.276699ef.jpg";